import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { nftL1PickingPendencyChange } from "../../../../api";
import Navbar from "../../../../containers/navbar";
import MainHeader from "../../../../containers/header";
import Header from "../../../../containers/content_header";
import ReportTemplate from "../../../../containers/report_template";
import ErrorModal from "../../../../containers/error_modal";

const NFTL1PickingPendency = ({ ...props }) => {
  const { loc, locationName, widthIsSmall } = props;
  const [pickingPendencyList, setPickingPendencyList] = useState([]);
  const [allPickingPendencyList, setAllPickingPendencyList] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  const [itemKeys, setItemKeys] = useState([]);
  const [lambdaError, setLambdaError] = useState("");
  const [isListLoading, setIsListLoading] = useState(false);
  const [isdownloadLoading, setIsdownloadLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const openErrRef = useRef();
  const closeErrRef = useRef();
  const tableHeads = [
    "bin",
    "item",
    "item desc",
    "extract id",
    "extract qty",
    "from loc",
    "age",
    "User ID",
  ];
  const isFirstRender = useRef(true);

  useEffect(() => {
    getPickingPendencySummary();

    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }
  }, [currentPage, searchText]);

  const getPickingPendencySummary = async () => {
    try {
      setPickingPendencyList([]);
      setIsListLoading(true);
      let payload = {
        loc: loc,
        start: currentPage * 10,
        length: 10,
        search_key: searchText,
        file: false,
      };
      const resData = await nftL1PickingPendencyChange(payload);

      if (resData) {
        if (resData?.status === "error") {
          setLambdaError(resData?.error_message);
          openErrRef.current.click();
        } else {
          if (Object.keys(resData?.body?.records)?.length) {
            let formattedData = resData?.body?.records?.map((item) => {
              return {
                bin: [...item?.bin].join(" , ") || "-",
                item: item?.item,
                item_desc: item?.item_desc,
                extract_id: item?.extract_id,
                extract_qty: item?.extract_qty,
                from_loc: item?.from_loc,
                age: item?.age,
                user_id: item?.user_id,
              };
            });
            setPickingPendencyList(formattedData);
            setAllPickingPendencyList(formattedData);
            setfilteredData(formattedData);
            setItemKeys(Object.keys(formattedData[0]));
            setTotalRecords(resData?.body?.totalRecords);
          } else {
            setTotalRecords(resData?.body?.totalRecords);
          }
        }
        setIsListLoading(false);
      } else {
        // setLambdaError("Something went wrong");
        // openErrRef.current.click();
        setIsListLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLambdaError(error);
      openErrRef.current.click();
      setIsListLoading(false);
    }
  };

  const onDownLoadS3Url = async () => {
    try {
      setIsdownloadLoading(true);
      let payload = {
        loc: loc,
        start: 0,
        length: 0,
        search_key: searchText,
        file: true,
      };
      const resData = await nftL1PickingPendencyChange(payload);
      if (resData) {
        if (resData?.status === "error") {
          setLambdaError(resData?.error_message);
          openErrRef.current.click();
        } else {
          if (resData?.body?.file_url) {
            window.open(resData?.body?.file_url);
          }
        }
      }
      // else {
      //   setLambdaError("Something went wrong");
      //   openErrRef.current.click();
      // }
      setIsdownloadLoading(false);
    } catch (error) {
      console.log(error);
      setLambdaError(error);
      openErrRef.current.click();
      setIsdownloadLoading(false);
    }
  };

  const addPageData = (pageData) => {
    setPickingPendencyList(pageData);
  };

  return (
    <>
      <MainHeader />
      <Navbar />
      <div
        className="lpn-hm d-flex flex-column"
        style={{ padding: widthIsSmall ? "0px" : "8px 24px" }}
      >
        <Header
          text={`${loc} - ${locationName}`}
          headerText={"NFT L1 Picking Pendency"}
        />
        <ReportTemplate
          widthIsSmall={widthIsSmall}
          tableHeads={tableHeads}
          itemKeys={itemKeys}
          data={pickingPendencyList}
          isTableLoading={isListLoading}
          loc={loc}
          buttonName={"Download NFT L1 Picking Pendency List"}
          filePrefix={"nftl1_picking_pendency"}
          searchText={(text) => setSearchText(text)}
          allData={allPickingPendencyList}
          addPageData={addPageData}
          pageCount={10}
          filteredData={filteredData}
          totalRecords={totalRecords}
          type={"paginationFromDb"}
          changePage={(pageNo) => setCurrentPage(pageNo)}
          onDownloadUrl={onDownLoadS3Url}
          isdownloadLoading={isdownloadLoading}
        />
        <ErrorModal
          id={"errorModal"}
          openRef={openErrRef}
          closeRef={closeErrRef}
          headerColor={"red"}
          msg={lambdaError}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loc: state?.auth?.user?.loc,
    locationName: state?.auth?.user?.locationName,
    widthIsSmall: state?.auth?.widthIsSmall,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NFTL1PickingPendency);
